import { Link } from "react-router-dom";
import { CONTACT } from "@/data/site";

const Footer = () => {
  return (
    <footer className="border-t border-white/8 pt-10 pb-4">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 flex flex-col md:flex-row gap-6 items-center justify-between">
        <div className="flex items-center gap-4">
          <img
            src="/brand/logo.png"
            alt="Athens Airport Taxi Transfers"
            className="h-32 w-auto select-none"
            draggable="false"
          />
          <div className="text-xs text-foreground/55 max-w-[14rem]">
            {CONTACT.address}
          </div>
        </div>

        <div className="flex flex-col items-center md:items-end gap-2 text-sm text-foreground/65">
          <div className="flex flex-wrap items-center justify-center gap-5">
            <a
              href={`https://wa.me/${CONTACT.phoneRaw}`}
              target="_blank"
              rel="noreferrer"
              className="hover:text-gold transition"
            >
              WhatsApp
            </a>
            <a
              href={`tel:+${CONTACT.phoneRaw}`}
              className="hover:text-gold transition"
            >
              {CONTACT.phone}
            </a>
          </div>
          <a
            href={`mailto:${CONTACT.email}`}
            className="hover:text-gold transition whitespace-nowrap"
          >
            {CONTACT.email}
          </a>
        </div>

        <div className="text-xs text-foreground/45">
          © {new Date().getFullYear()} Athens Airport Taxi Transfers. All rights reserved.
        </div>
      </div>

      {/* Legal micro-links — deliberately understated so the homepage stays
          clean but Google Ads / GDPR still have a link to policy pages. */}
      <div className="max-w-7xl mx-auto px-5 lg:px-10 mt-6 pt-4 border-t border-white/5 flex justify-center gap-5 text-[0.68rem] uppercase tracking-[0.16em] text-foreground/30">
        <Link
          to="/privacy"
          data-testid="footer-privacy-link"
          className="hover:text-foreground/60 transition-colors"
        >
          Privacy
        </Link>
        <span aria-hidden="true">·</span>
        <Link
          to="/terms"
          data-testid="footer-terms-link"
          className="hover:text-foreground/60 transition-colors"
        >
          Terms
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
